// extracted by mini-css-extract-plugin
export default {"addressMainContent":"MDv82","addressContent":"r_OBo","mainHeader":"v06YZ","title":"M69AK","description":"Aif1R"};